module.exports = __webpack_public_path__ + "img/americano.78805821.png";